module.exports = {
	"description": "CardImage renders images full-bleed inside of a [Card](../card).\nUse CardImage to display static media.",
	"methods": []
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Card/CardImage.js
// module id = 1602
// module chunks = 0